export interface ILocationSettingConfig {
  [key: string]: {
    settingsPath: string
    routerName: string
    productTitle: string
    knowMoreUrl: string
    productUnitText?: string
    productUnit?: string
    enableModalContent: { html: string; isAgency497Check?: boolean }[]
  }
}

export const LOCATION_SETTING_CONFIG: ILocationSettingConfig = {
  conversationAI: {
    settingsPath: '/settings/ai-employees',
    routerName: 'location-setting-ai-employees',
    productTitle: 'AI Employee',
    knowMoreUrl: 'https://help.gohighlevel.com/support/solutions/articles/155000003906-ai-employee',
    enableModalContent: [
      { html: '<b>Conversation AI</b> is chargeable for every message generation. The price is $0.02/message.' },
      {
        html:
          'Enable <b>Conversation AI in SaaS Configurator</b> and adjust the re-bill amount over the default price.',
      },
      {
        html:
          'Enable the <b>Conversation AI Re-billing</b> for the sub account to charge your Sub Accounts (Locations) based on their usage.',
      },
      {
        html:
          'On enabling Conversation AI Bot, based on usage around $0.02/message will be debited from the Agency Wallet for each message generated from any of the Agency Sub Accounts (Locations).',
      },
      {
        html:
          'There are 2 modes that need to be enabled from each Sub Accounts (Locations) Settings: <ul> <li class="py-1">Auto-pilot Mode - The bot automatically sends out a response to inbound messages</li><li class="py-1">Suggestive Mode - The bot provides suggestions whenever a GHL user starts typing in the message box got SMS, FB and IG</li></ul>',
      },
      { html: 'Each instance of a message/suggestion generation in both of the modes is charged at $0.02/message.' },
    ],
  },
  reviewsAI: {
    settingsPath: '/settings/reviews-ai',
    routerName: 'location-setting-reviews-ai',
    productTitle: 'Reviews AI',
    knowMoreUrl: 'https://help.gohighlevel.com/a/solutions/articles/155000001074?portalId=48000045315',
    enableModalContent: [
      {
        html:
          '<b>Reviews AI</b> feature is chargeable for every message generation. This price is $0.08/review response.',
      },
      { html: 'Enable <b>Reviews Al in SaaS Configurator</b> and adjust the re-bill amount over the default price.' },
      {
        html:
          'Enable the <b>Reviews Al Re-billing</b> for the sub account to charge your Sub Accounts (Locations) based on their usage.',
      },
      {
        html:
          'On enabling Reviews Al Bot, based on usage around $0.08/message will be debited from the Agency Wallet for each message generated from any of the Agency Sub Accounts (Locations).',
      },
      { html: 'There are 2 modes that need to be enabled from each Sub Accounts (Locations) Settings:' },
      {
        html:
          '<b>Auto Response Mode</b> - The bot automatically sends out a response to new reviews obtained from review platforms.',
      },
      { html: '<b>Suggestive Mode</b> - The user can also regenerate responses up-to 3 times for no additional cost.' },
      { html: 'Each instance of a response/suggestion generation in both of the modes is charged at $0.08/message.' },
    ],
  },
  workflow_premium_actions: {
    settingsPath: '/settings/workflow-premium-features',
    routerName: 'location-setting-workflow-premium-features',
    productTitle: 'Workflow - Premium Features',
    knowMoreUrl:
      'https://help.gohighlevel.com/support/solutions/articles/155000005678-how-to-enable-and-rebill-premium-features-for-workflows',
    productUnitText: 'execution',
    enableModalContent: [
      {
        html:
          '<b>Premium Features</b> are chargeable for each execution and the default price is 0.01$/execution.',
      },
      {
        html:
          'You can enable <b>Premium Features in SaaS Configurator</b> and adjust the re-bill amount over the default price.',
        isAgency497Check: true,
      },
      {
        html:
          'Enable the <b>Premium Features Re-billing</b> for the sub account to charge your Sub Accounts (Locations) based on their usage.',
        isAgency497Check: true,
      },
      {
        html:
          'On enabling Premium Features, 0.01$/execution will be debited from the Agency Wallet for each execution from any of the Agency Sub Accounts (Locations).',
      },
      { html: 'Each Sub Account (Location) will get 100 free executions to start off.' },
    ],
  },
  workflow_ai: {
    settingsPath: '/settings/workflow-external-ai-models',
    routerName: 'location-setting-workflow-external-ai-models',
    productTitle: 'Workflow - External AI Models',
    knowMoreUrl:
      'https://help.gohighlevel.com/support/solutions/articles/155000000169-how-to-enable-and-rebill-workflow-ai-',
    productUnitText: 'execution',
    enableModalContent: [
      { html: '<b>External AI Models</b> feature is chargeable for each execution. You pay exactly what the AI model provider charges us.' },
      {
        html:
          "You can enable <b>External AI Models in SaaS Configurator</b> and adjust the re-bill amount over the provider's cost.",
        isAgency497Check: true,
      },
      {
        html:
          'Enable the <b>External AI Models Re-billing</b> for the sub account to charge your Sub Accounts (Locations) based on their usage.',
        isAgency497Check: true,
      },
      {
        html:
          'On enabling External AI Models, the exact cost charged by the AI model provider will be debited from the Agency Wallet for each execution from any of the Agency Sub Accounts (Locations).',
      },
    ],
  },
  contentAI: {
    settingsPath: '/settings/content-ai',
    routerName: 'location-setting-content-ai',
    productTitle: 'Content AI - Text And Image',
    knowMoreUrl: 'https://help.gohighlevel.com/support/solutions/articles/48001234826-how-to-enable-and-rebill-content-ai-',
    enableModalContent : [
        { html: '<b>Content AI</b> feature is chargeable for every use based on words calculation. The price is $0.09/1000 words.' },
        { html: 'Enable <b>Content AI in SaaS Configurator</b> and adjust the re-bill amount based on the default price.', isAgency497Check: true },
        { html: 'Enable the <b>Content AI Re-billing</b> for the sub account to charge your Sub-Accounts based on their usage.', isAgency497Check: true },
        { html: 'On enabling Content AI, based on usage around $0.09/1000 words will be debited from the Agency Wallet for each word from any of the Agency Sub Accounts (Locations).' },
        { html: 'Each Sub Account (Location) will get 500 free words to start off.' },
        { html: 'Pricing varies based on the number of words used in the prompt, the product area it\'s activated from and the words generated.' },
    ]
},
  domainPurchase:{
    settingsPath:'/settings/domain-purchase',
    routerName:'location-setting-domain-purchase',
    productTitle:'Domain Purchase',
    knowMoreUrl: 'https://help.gohighlevel.com/support/solutions/articles/155000003454-how-to-enable-and-rebill-domain-purchase-',
    enableModalContent : [
        {html: 'Domain is chargeable for every domain purchase. The price of domain varies depending upon domain name and TLDs (like .com, .us, etc.)'},
        {html: 'You can enable Domain in SaaS Configurator and adjust the re-bill amount over the default price.'},
        {html: 'Enable the Domain Re-billing for the sub account to charge your Sub Accounts (Locations) based on their domain purchases.'},
        {html: 'On enabling Domain, based on the domain price, the amount will be debited from the Agency Wallet (if location do not have payment method setup) or Location wallet (if locations payment method is setup) for each domain purchased from any of the Agency Sub Accounts (Locations).'},
    ]
  },
  autoCompleteAddress:{
    settingsPath:'/settings/auto-complete-address',
    routerName:'location-setting-auto-complete-address',
    productTitle:'Auto-Complete Address',
    knowMoreUrl: 'https://help.gohighlevel.com/support/solutions/articles/155000003739-how-to-rebill-autocompleted-address',
    enableModalContent : [
        {html: 'The Auto-Complete Address feature allows users to search for an address similar to Google Maps. Selecting an address will auto-fill fields like street, city, and postal code, enhancing address accuracy and user experience'},
        {html: 'This feature is chargeable per use. Pricing depends on usage volume.'},
        {html: 'Enable Auto-Complete Address in the SaaS Configurator and adjust the re-bill amount over the default price.'},
        {html: 'Enable the Auto-Complete Address Re-billing for the sub account to charge your Sub Accounts (Locations) based on their address lookup usage.'},
        {html:"On enabling Auto-Complete Address, based on the usage, the amount will be debited from the Agency Wallet (if location do not have payment method setup) or Location wallet (if location's payment method is setup) for each address lookup performed by any of the Agency Sub Accounts (Locations)."}
    ]
  },
}
